/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountsRouteImport } from './routes/accounts'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as LxcRouteImport } from './routes/lxc'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsRoute = AccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsRoute = JobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const LxcRoute = LxcRouteImport.update({
  id: '/lxc',
  path: '/lxc',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRoute
  '/audit': typeof AuditRoute
  '/jobs': typeof JobsRoute
  '/lxc': typeof LxcRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRoute
  '/audit': typeof AuditRoute
  '/jobs': typeof JobsRoute
  '/lxc': typeof LxcRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRoute
  '/audit': typeof AuditRoute
  '/jobs': typeof JobsRoute
  '/lxc': typeof LxcRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/accounts' | '/audit' | '/jobs' | '/lxc'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/accounts' | '/audit' | '/jobs' | '/lxc'
  id: '__root__' | '/' | '/accounts' | '/audit' | '/jobs' | '/lxc'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountsRoute: typeof AccountsRoute
  AuditRoute: typeof AuditRoute
  JobsRoute: typeof JobsRoute
  LxcRoute: typeof LxcRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts': {
      id: '/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lxc': {
      id: '/lxc'
      path: '/lxc'
      fullPath: '/lxc'
      preLoaderRoute: typeof LxcRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsRoute: AccountsRoute,
  AuditRoute: AuditRoute,
  JobsRoute: JobsRoute,
  LxcRoute: LxcRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
